<template>
  <v-navigation-drawer
    app
    :temporary="isSmall"
    :permanent="!isSmall"
    :expand-on-hover="!isSmall"
    :mini-variant.sync="mini"
    v-model="localValue"
  >
    <v-list-item class="pl-2">
      <v-avatar color="orange" size="40" class="mr-2">
        <v-img src="../../assets/default-user.png"/>
      </v-avatar>
      <v-list-item-content>
        <v-list-item-title class="title">
          <strong v-if="user">{{ user.nome }}</strong>
        </v-list-item-title>
        <v-list-item-subtitle>
          Bem-vindo!
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-divider/>
    <v-list dense>
      <v-list-group
        active-class="grey--text text--darken-2"
        value="true"
      >
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon>mdi-chart-areaspline</v-icon>
          </v-list-item-icon>
          <v-list-item-title dense>Indicadores</v-list-item-title>
        </template>
        <v-list-item
          link
          active-class="orange--text"
          :class="groupItemClass"
          to="/meu-painel"
        >
          <v-list-item-icon>
            <v-icon>mdi-monitor-dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Meu painel</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>

    <v-list dense>
      <v-list-group
        active-class="grey--text text--darken-2"
        value="true"
      >
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon>mdi-shopping-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title dense>Negócios</v-list-item-title>
        </template>
        <v-list-item
          link
          active-class="orange--text"
          :class="groupItemClass"
          to="/cotacoes"
        >
          <v-list-item-icon>
            <v-icon>mdi-currency-usd</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Cotações de frete</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          link
          :class="groupItemClass"
          active-class="orange--text"
          to="/contratacoes"
        >
          <v-list-item-icon>
            <v-icon>mdi-shopping</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Contratações de frete</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          link
          active-class="orange--text"
          :class="groupItemClass"
          to="/painel"
        >
          <v-list-item-icon>
            <v-icon>mdi-view-list</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Painel de cotações</v-list-item-title>
          </v-list-item-content>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-icon color="yellow darken-2">mdi-crown-outline</v-icon>
            </span>
            </template>
            <span>Recurso premium</span>
          </v-tooltip>
        </v-list-item>
      </v-list-group>
    </v-list>
    <v-list dense>
      <v-list-group
        active-class="grey--text text--darken-2"
        value="true"
      >
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon>mdi-office-building</v-icon>
          </v-list-item-icon>
          <v-list-item-title dense>Empresa</v-list-item-title>
        </template>
        <v-list-item
          link
          :class="groupItemClass"
          to="/minha-empresa"
          active-class="orange--text"
        >
          <v-list-item-icon>
            <v-icon>mdi-domain</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Minha empresa</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          link
          :class="groupItemClass"
          to="/locais-coleta"
          active-class="orange--text"
        >
          <v-list-item-icon>
            <v-icon>mdi-map-marker</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Locais de coleta</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
<!--        <v-list-item-->
<!--          link-->
<!--          :class="groupItemClass"-->
<!--          to="/usuarios"-->
<!--          active-class="orange&#45;&#45;text"-->
<!--        >-->
<!--          <v-list-item-icon>-->
<!--            <v-icon>mdi-account-multiple</v-icon>-->
<!--          </v-list-item-icon>-->
<!--          <v-list-item-content>-->
<!--            <v-list-item-title>Usuários</v-list-item-title>-->
<!--          </v-list-item-content>-->
<!--        </v-list-item>-->
      </v-list-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: ['value'],
  data() {
    return {
      mini: true,
    };
  },
  computed: {
    ...mapGetters('user', ['user']),
    localValue: {
      get() { return this.value; },
      set(localValue) { this.$emit('input', localValue); },
    },
    groupItemClass() {
      return this.mini ? '' : 'group-item';
    },
    isSmall() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    miniComputed: {
      get() {
        return this.isSmall;
      },
    },
  },
  created() {
    if (this.isSmall) {
      this.mini = false;
    }
  },
};
</script>

<style scoped>
  .group-item {
    padding-left: 30px !important;
  }
</style>
